import React from 'react'
import { TextInput } from '@common/ui'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.entity.field.Field

export type EntityFormNumberDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormNumberDisplay = ({ field, fieldValue }: EntityFormNumberDisplayProps) => {
  const loading = fieldValue === undefined
  return (
    <TextInput
      disabled
      required={field.required}
      label={field.name}
      value={fieldValue?.value ?? ''}
      placeholder={loading ? ' ' : undefined}
    />
  )
}

export default EntityFormNumberDisplay
